import React, {Component} from 'react';
import {
    Button,
    Modal,
    Form,
    Message,
    Popup,
    List
} from 'semantic-ui-react';
import Alert from "../../components/extras/Alert";

import connect from "react-redux/es/connect/connect";
import CustomDivider from "../extras/CustomDivider";
import Loading from "../extras/Loading";
import {addCombo, listCombo} from "../../actions/ComboActions";
import {showToast} from "../../actions/ToastAction";
import {productRecipesDialog} from "../../actions/ProductRecipesDialogActions";
import helpers from "../../functions/helpers";
import RecipeData from "../../data/RecipeData";
import ProductRecipeItem from "./ProductRecipeItem";
import update from "react-addons-update";
import IngredientData from "../../data/IngredientData";
import ProductCompoundData from "../../data/ProductCompoundData";

const c = require("../../constants");

class ProductCompoundDialog extends Component {

    constructor() {
        super();

        this.state = {
            options_recipes: [],
            compound_error: false,
            quantity_error: false,
            data:{
                compound:null,
                quantity:1,
                can_excluded: false,
                compound_type:'I'
            },
            loading: true,
            loading_add:false,
            id: null,
            height: 80
        };
        this.loadData = this.loadData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.modal.id && nextProps.modal.id !== this.state.id){
            this.setState({loading:true, id: nextProps.modal.id});
            this.initialFetch(nextProps.modal.id);
        }
        if(nextProps.modal.is_open){
            this.loadData();
        }
    }

    componentWillMount(){
        this.loadData();
    };

    async initialFetch(id) {
        let products = await ProductCompoundData.list(id);
        let height = products.length > 0 ? 200:80;
        this.setState({loading: false, height});
        this.props.listCombo(products);
    }

    loadData() {
        RecipeData.getAll((options) => this.setState({options_recipes: helpers.mapOptionsWithName(options)}))

        IngredientData.list().then(ingredients => {
            let options_ingredients = ingredients.map(ingredient => {
                return {key:ingredient.id, value:ingredient.id, text:`${ingredient.name} - ${c.UNITS.find((unit) => unit.key===ingredient.unit).text}`}
            });
            this.setState({options_ingredients});
        });
    };

    handleClose = () => {
        this.setState({
            id: null,
            loading: false,
        });
        this.props.productRecipesDialog({
            is_open:false,
            loading:false,
            name:null,
            id:null
        });
        this.props.listCombo([]);
    };

    handleChange = (e, { name, value }) => {
        let data = this.state.data;
        data[name]= value;
        this.setState({data, compound_error:false, quantity_error:false});
    };

    handleTypeChange = (result) => {
        let compound = update(this.state, {
            data: {
                compound_type:  {$set: result},
                compound: {$set: null}
            }
        });
        this.setState(compound);
    };

    async handleSubmit() {
        if(this.state.data.compound === null){
            this.setState({compound_error:true});
        }else if(this.state.data.quantity <= 0){
            this.setState({quantity_error:true});
        }else {
            let data = this.state.data;
            data.product = this.state.id;
            this.add(data);
        }
    };

    handleCanExcluded = () => {
        let can_excluded = update(this.state, {
            data: {
                can_excluded: {
                    $set: !this.state.data.can_excluded
                }
            }
        });
        this.setState(can_excluded);
    };

    async add(data) {
        this.setState({loading_add:true});
        ProductCompoundData.add(data, (res) => {
            if (res.save) {
                this.props.addCombo(res.data);
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Esta receta ya está en la lista!'
                });
            }
            this.setState({loading_add:false});
        });
    };

    render() {
        let listItems = this.props.product_combo.map(function (recipe) {
            return (
                <ProductRecipeItem {...recipe} key={recipe.id}/>
            )
        }, this);

        let data = (this.props.product_combo.length > 0 ? listItems :
                <Message icon='bell' header='No hay información registrada'/>
        );

        return (
            <div>
                <Modal open={this.props.modal.is_open} dimmer='inverted' size='small' onClose={this.handleClose}>
                    <Modal.Header>{`${this.props.modal.name} - Componentes`}</Modal.Header>
                    <Modal.Content image scrolling>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Group>
                                    <Form.Dropdown
                                        options={c.COMPOUND_TYPES}
                                        value={this.state.data.compound_type}
                                        width={4}
                                        compact
                                        selection
                                        onChange={(e, {value}) => this.handleTypeChange(value)}
                                        placeholder='Tipo de Compuesto'
                                        error={this.state.type_error}
                                    />
                                    <Form.Dropdown
                                        options={this.state.data.compound_type === 'I' ? this.state.options_ingredients:this.state.options_recipes}
                                        placeholder={this.state.data.compound_type === 'I' ? 'Ingrediente':'Receta'}
                                        name='compound'
                                        onChange={this.handleChange}
                                        search
                                        width={5}
                                        selection
                                        error={this.state.compound_error}
                                    />
                                    <Form.Input
                                        placeholder='Cant.'
                                        type='number'
                                        name='quantity'
                                        min={0}
                                        step={'.01'}
                                        width={3}
                                        value={this.state.data.quantity}
                                        onChange={this.handleChange}
                                        error={this.state.quantity_error}
                                    />
                                    <Popup
                                        content='Permitir a los comensales excluir de la comanda'
                                        trigger={<Form.Checkbox width={2} style={{marginTop:'1em'}} label='Opcional ' checked={this.state.can_excluded} onChange={this.handleCanExcluded} />}
                                    />

                                    <Form.Button
                                        circular
                                        icon='add'
                                        primary
                                        width={2}
                                        disabled={this.state.loading_add}
                                        loading={this.state.loading_add}
                                    />
                                </Form.Group>
                            </Form>
                            <CustomDivider/>
                            <div className='modal-content-scroll' style={{height:this.state.height}}>
                                <List divided verticalAlign='middle'>
                                    {this.state.loading ? <Loading /> : data}
                                </List>
                            </div>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
                <Alert ref='alert'/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        productRecipesDialog(modal) {
            dispatch(productRecipesDialog(modal))
        },
        listCombo(data){
            dispatch(listCombo(data))
        },
        addCombo(data){
            dispatch(addCombo(data))
        },
        showToast(alert) {
            dispatch(showToast(alert));
        },
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('product_recipes_dialog'),
        product_combo: state.get('combo'),
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductCompoundDialog)


// WEBPACK FOOTER //
// ./src/components/inventories/ProductCompoundDialog.js